<!--
 * @创建文件时间: 2019-12-29 19:32:42
 * @Auther: lfq
 * @最后修改人: lfq
 * @最后修改时间: 2020-05-10 13:37:11
 * @联系Qq:1638245306
 * @文件介绍: 
 -->
<template>
    <div>
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" @close="$emit('update:dialogFormVisible', false)" :append-to-body="true">
     
        <dynamic-tree 
        :nodeKey="nodeKey"
        :treeData='treeData'
        :defaultCheckedKeys="defaultCheckedKeys"
        :treeConfig='treeConfig'
        @setChecked="setChecked"
        ></dynamic-tree>
        <div slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible=false">取 消</el-button> 
            <el-button type="primary" @click="onSubmit">保 存</el-button>
        </div>
    </el-dialog>
    </div>
</template>

<script>
  export default {
    name: 'dialogTree',
    data(){
      return {
       refName:'',
       dialogVisible:this.dialogFormVisible,
       checkedList:[]
      }
    },
    props: {
      nodeKey:{
        type:String,
        default:'id'
      },
      defaultCheckedKeys:{
        type:Array,
        default:()=>[]
      },
      treeData:{
        type:Array,
        default:()=>[]
      },
      dialogTitle:{
        type:String
      },
      dialogFormVisible:{
        type:Boolean,
        default:false
      },
      treeConfig:{
        type:Object,
        default:()=>{
          return{
            'label':'label',
            'children':'children'
          }  
        }
      },
      disabled:{
        type:Boolean,
        default:false
      },
    },
    watch:{
      dialogFormVisible(val, oldVal) {
      if (val === oldVal) {
        return
      }
      this.dialogVisible = val
      }
    },
    methods:{
      //设置选中项
      setChecked(val){
         this.checkedList = val;
      },
      onSubmit(){
        let that = this
        that.$emit('onSubmit',that.checkedList)
      }
    },
    created() {
      this.refName = 'dialogTree' + new Date().getTime()
      
    },
    mounted() {
     
    },
  }
</script>

<style scoped>

</style>

<vue-filename-injector>
export default function (Component) {
  Component.options.__source = "src/components/aboutForm/dialogTree.vue"
}
</vue-filename-injector>
